import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateExamination,
    deleteExamination,
    getPageExaminations,
} from '../ExaminationEndPoint'

export const usePageExaminations = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {examinationKeys} = QueryKeyManager(
        QueryKeyTypes.examination,
        requestorId,
    )

    return useQuery({
        queryKey: examinationKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageExaminations(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useExaminationCRUD = (type, requestorId) => {
    const {examinationKeys} = QueryKeyManager(
        QueryKeyTypes.examination,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateExamination(requestorId, data)
                : type === QueryCRUDTypes.delete
                ? deleteExamination(requestorId, data?.id)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Examination Update Successfully !!',
                    )
                } else if (type === QueryCRUDTypes.delete) {
                    showNotification(
                        severityNotification.success,
                        'Deletion performed successfully!!',
                    )
                }
            }
        },
    })
}
